import { render } from "./manufacturers.vue?vue&type=template&id=0d6f388d&ts=true"
import script from "./manufacturers.vue?vue&type=script&lang=ts"
export * from "./manufacturers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__